import React, { Component } from "react";
import "./OwPickList.scss";
import * as _ from "lodash-es";
import OwButton from "../OwButton/OwButton";
import OwTitle from "../OwTitle/OwTitle";

type Props = {
    className?: string;
    availableOptions: any[];
    titleProp: string;
    valueProp: string;
    selectedOptions: any[];
    saveFn: (selectedOptionsArr: any[]) => void;
};

type State = {
    availableOptions: any[];
    selectedOptions: any[];
    availableOptionsArr: any[];
    selectedOptionsArr: any[];
    originalAvailableOptionsArr?: any[];
    originalSelectedOptionsArr?: any[];
};

class OwPickList extends Component<Props, State> {
    availableOptionsRef = React.createRef<any>();
    selectedOptionsRef = React.createRef<any>();

    readonly state: State = {
        availableOptions: this.props.availableOptions,
        selectedOptions: this.props.selectedOptions,
        availableOptionsArr: [],
        selectedOptionsArr: [],
    };

    componentDidMount() {
        this.setupOptions();
    }

    setupOptions = () => {
        const titleProp = this.props.titleProp;
        const valueProp = this.props.valueProp;

        const availableOptions = this.props.availableOptions;

        const availableOptionsArrPreFilter = _.map(availableOptions, (option, index) => {
            const title = _.get(option, `${titleProp}`, "");
            const value = _.get(option, `${valueProp}`, "");

            return { value: value, title: title };
        });

        const selectedOptionsArr = _.map(this.props.selectedOptions, (option, index) => {
            const title = _.get(option, `${titleProp}`, "");
            const value = _.get(option, `${valueProp}`, "");

            return { value: value, title: title };
        });

        const availableOptionsArr = _.filter(availableOptionsArrPreFilter, (availOption, availIndex) => {
            let found = false;
            _.forEach(selectedOptionsArr, (selectedOption, selectIndex) => {
                if (availOption.value === selectedOption.value) {
                    found = true;
                }
            });

            if (!found) {
                return availOption;
            }
        });

        this.setState({
            availableOptionsArr,
            selectedOptionsArr,
            originalAvailableOptionsArr: availableOptionsArr,
            originalSelectedOptionsArr: selectedOptionsArr,
        });
    };

    getAvailableOptions = () => {
        const sortedArr = _.sortBy(this.state.availableOptionsArr, ["title"]);

        return _.map(sortedArr, (option, index) => {
            return (
                <option key={index} value={option.value} data-testid={"available-option"}>
                    {option.title}
                </option>
            );
        });
    };

    getSelectedOptions = () => {
        const sortedArr = _.sortBy(this.state.selectedOptionsArr, ["title"]);

        return _.map(sortedArr, (option, index) => {
            return (
                <option key={index} value={option.value} data-testid={"selected-option"}>
                    {option.title}
                </option>
            );
        });
    };

    addRows = () => {
        this.processSwap(
            this.state.availableOptionsArr,
            this.state.selectedOptionsArr,
            this.availableOptionsRef,
            "availableOptionsArr",
            "selectedOptionsArr"
        );
    };

    processSwap = (sourceArr: any[], destinationArr: any[], refObject: any, sourceArrState: any, destinationArrState: any) => {
        // remove the options from the availableOptions, options array.
        const currentAvailableOptions = sourceArr;
        const selectedAvailableOptions = destinationArr;
        const optionsToAdd: any[] = [];

        _.each(refObject.current.selectedOptions, (option) => {
            const optionObj = { value: option.value, title: option.textContent };

            optionsToAdd.push(optionObj);
        });

        // Join the Currently Selected Options with the New Options Coming Over
        let updatedSelectedAvailableOptions = selectedAvailableOptions.concat(optionsToAdd);

        // Sort The Options By Title
        updatedSelectedAvailableOptions = _.sortBy(updatedSelectedAvailableOptions, [
            (o) => {
                return o.title;
            },
        ]);

        // Filter out the availableOptions
        const updatedAvailableOptions: any[] = [];

        _.each(currentAvailableOptions, (option) => {
            let hasOption = false;

            for (const selectedOption of updatedSelectedAvailableOptions) {
                if (!_.isNaN(Number(selectedOption.value))) {
                    if (Number(selectedOption.value) === Number(option.value)) {
                        hasOption = true;
                    }
                } else {
                    if (selectedOption.value === option.value) {
                        hasOption = true;
                    }
                }
            }

            if (!hasOption) {
                updatedAvailableOptions.push(option);
            }
        });

        const state: any = {
            [sourceArrState]: updatedAvailableOptions,
            [destinationArrState]: updatedSelectedAvailableOptions,
        };

        this.setState(state);
    };

    removeRows = () => {
        this.processSwap(
            this.state.selectedOptionsArr,
            this.state.availableOptionsArr,
            this.selectedOptionsRef,
            "selectedOptionsArr",
            "availableOptionsArr"
        );
    };

    saveSelected = () => {
        this.props.saveFn(this.state.selectedOptionsArr);
    };

    handleSelectedFilterChange = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const newState: any = {
            [name]: value,
        };

        if (!value.length) {
            newState["selectedOptionsArr"] = this.state.originalSelectedOptionsArr;
        } else {
            newState["selectedOptionsArr"] = _.filter(this.state.selectedOptionsArr, (option) => {
                if (!_.isNil(option.title)) {
                    return option.title.match(value);
                } else {
                    return false;
                }
            });
        }

        this.setState(newState);
    };

    handleAvailableFilterChange = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        const availableOptions = this.getAvailableOptions();
        const selectedOptions = this.getSelectedOptions();

        return (
            <div className={"OwPickList row " + this.props.className}>
                <div className={"col-12 col-md-5"}>
                    <OwTitle tag={"h5"} title={"available_options"} />

                    {/*<OwInputWrapper*/}
                    {/*name={"availableFilter"}*/}
                    {/*placeholder={"available_filter"}*/}
                    {/*fn={this.handleAvailableFilterChange}*/}
                    {/*value={this.state.availableFilter}*/}
                    {/*/>*/}
                    <select ref={this.availableOptionsRef} multiple={true} className={"w-100 form-control available-options"}>
                        {availableOptions}
                    </select>
                </div>

                <div className={"col-12 col-md-2 text-center"}>
                    <div className={"mb-2 mt-2 mt-md-0"}>
                        <OwButton testId={"add-btn"} className={"btn-primary add-btn"} fn={this.addRows} rightIconClass={"far fa-arrow-right"} title={"add"} />
                    </div>
                    <div className={"mb-4"}>
                        <OwButton
                            className={"btn-danger remove-btn"}
                            fn={this.removeRows}
                            leftIconClass={"far fa-arrow-left"}
                            title={"remove"}
                        />
                    </div>
                    <div>
                        <OwButton testId={"save-btn"} className={"btn-primary save-btn"} fn={this.saveSelected} leftIconClass={"far fa-save"} title={"save"} />
                    </div>
                </div>

                <div className={"col-12 col-md-5"}>
                    <OwTitle tag={"h5"} title={"selected_options"} />
                    {/*<OwInputWrapper*/}
                    {/*name={"selectedFilter"}*/}
                    {/*placeholder={"selected_filter"}*/}
                    {/*fn={this.handleSelectedFilterChange}*/}
                    {/*value={this.state.selectedFilter}*/}
                    {/*/>*/}
                    <select ref={this.selectedOptionsRef} multiple={true} className={"w-100 form-control selected-options"}>
                        {selectedOptions}
                    </select>
                </div>
            </div>
        );
    }
}

export default OwPickList;
